const SUPER_PERMISSION = '*'

export const canAccessMenuItem = (item, permissions = []) => {
  if (item?.superOnly) {
    return permissions.includes(SUPER_PERMISSION)
  }

  if (Array.isArray(item?.anyOf) && item.anyOf.length > 0) {
    return (
      permissions.includes(SUPER_PERMISSION) ||
      item.anyOf.some((permission) => permissions.includes(permission))
    )
  }

  if (!item?.permission) {
    return true
  }

  return permissions.includes(SUPER_PERMISSION) || permissions.includes(item.permission)
}

export const filterNavigationRoutes = (activeRoutes, permissions = []) =>
  activeRoutes
    .map((route) => {
      if (route.path) {
        return canAccessMenuItem(route, permissions) ? route : null
      }

      const visibleChildren = (route.children || []).filter((child) =>
        canAccessMenuItem(child, permissions)
      )

      if (visibleChildren.length === 0 || !canAccessMenuItem(route, permissions)) {
        return null
      }

      return {
        ...route,
        children: visibleChildren,
      }
    })
    .filter(Boolean)
